















import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import BaseAvatar from "@/components/BaseAvatar";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";

export default defineComponent({
  name: "StreamMessage",
  components: { ScreenNamePrinter, BaseAvatar },
  props: {
    message: { type: Object as () => Message, required: true },
  },
});
